import gql from 'graphql-tag'
import { dateFormat } from 'queries'

export const MATCH_PERSON = gql`
  query MatchPerson($descriptorId: String, $personId: String!, $listId: String, $descriptorIds: [String], $limit: Int) {
    person(uuid: $personId) {
      uuid
      userData
      createTime(format: "${dateFormat}")
      portrait
      descriptors {
        uuid
        portrait
      }
      lists {
        uuid
        listData
      }
    }
    match(
      descriptorId: $descriptorId, personId: $personId,
      listId: $listId, descriptorIds: $descriptorIds, limit: $limit
    ) {
      descriptor {
        uuid
        portrait
        lastUpdate(format: "${dateFormat}")
        person {
          portrait
          uuid
          userData
        }
      }
      similarity
    }
  }
`

export const MATCH_FACE = gql`
  query MatchFace($descriptorId: String!, $personId: String, $listId: String, $descriptorIds: [String], $limit: Int) {
    descriptor(uuid: $descriptorId) {
      uuid
      lastUpdate(format: "${dateFormat}")
      portrait
      lists {
        uuid
        listData
      }
      person {
        uuid
        userData
        portrait
      }
    }
    match(
      descriptorId: $descriptorId, personId: $personId,
      listId: $listId, descriptorIds: $descriptorIds, limit: $limit
    ) {
      descriptor {
        uuid
        portrait
        lastUpdate(format: "${dateFormat}")
        person {
          portrait
          uuid
          userData
        }
      }
      similarity
    }
  }
`

export const IDENTIFY_PERSON = gql`
  query IdentifyPerson($descriptorId: String, $personId: String!, $listId: String, $personIds: [String], $limit: Int) {
    person(uuid: $personId) {
      uuid
      userData
      createTime(format: "${dateFormat}")
      portrait
      descriptors {
        uuid
        portrait
      }
      lists {
        uuid
        listData
      }
    }
    identify(
      descriptorId: $descriptorId, personId: $personId,
      listId: $listId, personIds: $personIds, limit: $limit
    ) {
      similarity
      person {
        uuid
        userData
        createTime(format: "${dateFormat}")
        portrait
        descriptors {
            uuid
            portrait
        }
      }
    }
  }
`

export const IDENTIFY_FACE = gql`
  query IdentifyFace($descriptorId: String!, $personId: String, $listId: String, $personIds: [String], $limit: Int) {
    descriptor(uuid: $descriptorId) {
      uuid
      lastUpdate(format: "${dateFormat}")
      portrait
      lists {
        uuid
        listData
      }
      person {
        uuid
        userData
        portrait
      }
    }
    identify(
      descriptorId: $descriptorId, personId: $personId,
      listId: $listId, personIds: $personIds, limit: $limit
    ) {
      similarity
      person {
        uuid
        userData
        createTime(format: "${dateFormat}")
        portrait
        descriptors {
            uuid
            portrait
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/queries/matching/index.js